import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";
import { Modal, Button } from "react-bootstrap";
import { useState } from "react";
const Mun = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMagazine, setSelectedMagazine] = useState({
    title: "",
    url: "",
  });

  const handleOpenModal = (title, url) => {
    setSelectedMagazine({ title, url });
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);
  const homeMenu = [
    { label: "MUN", link: "/Mun" },
    { label: "Glory to the Nation", link: "/GloryOfNation" },
    {
      label: "Spic Macay Cultural and Heritage Club",
      link: "/SpocmacyColtoralHeritage",
    },
    {
      label: "Vocational Education Clubs (Middle Wing) ",
      link: "/vocationalClubmiddle",
    },
    {
      label: "Vocational Education Clubs (Senior Wing)",
      link: "/vocationalClub",
    },
    {
      label: "Vocational Education Clubs (Primary Wing)",
      link: "/VocationalClubPrimary",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/blog-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle pageTitle="Mun" breadEnd="Mun" breadMid="Mun" />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <h4>REPORT LOTUS SANSAD 2025</h4>
              <p>
                <b>
                  LOTUS SANSAD 2025- JANNITI SE JANKALYAN, FROM PUBLIC POLICY TO
                  PUBLIC WELFARE 
                </b>
              </p>

              <p>
                Lotus Valley International School, Gurugram, celebrated its
                second edition of Lotus Sansad 2025, a telling testament to the
                power of youth, on 30th and 31st May 2025. The imposing theme,
                Janniti se Jankalyan, from Public Policy to Public Welfare,
                signified more than a flourish of rhetoric, underscoring the
                imperative of transforming legislative intent into measurable
                societal impact.
                <br />
                The Inaugural Ceremony of Lotus Sansad 2025 unfolded with
                grandeur and grace in the school auditorium.  The morning
                commenced with a soulful performance by the school choir,
                followed by a warm welcome address by the stalwart leader of
                this academic sanctuary, Ms Anita Malhotra.
                <br />
                The ceremony was graced by the esteemed presence of Ambassador
                Anil Trigunayat, a former Indian Foreign Service officer, who
                delivered a compelling keynote address. Emphasising the
                significance of accountability, inclusivity, and
                self-empowerment, he described the youth as the real pivot of
                change. His thought-provoking message encouraged students to
                question, seek, and lead, rooted in India’s civilizational ethos
                of inquiry. He noted India’s rising stature as the “voice of
                sanity” in global politics.
                <br />
                The Director, Ms Anita Malhotra, delivered a visionary
                address that inspired the audience to embrace purpose-led
                leadership. The event also featured a mesmerising dance
                performance and the unveiling of Mission Sansad, a montage
                showcasing the journey of the Secretariat. The Core
                Secretariat’s exordium concluded the ceremony on a note of
                promise and conviction.
                <br />
                The Valedictory Ceremony commenced with a soulful rendition by
                the school Choir ‘Jaage hain der tak, yeh jo desh hai tera…’,
                and was graced by Mr Devender Mishra, IRS, Former Chief
                Commissioner of Customs, presently an Advisor to the Food
                Corporation of India. In his riveting keynote address, he
                emphasised the importance of identifying our fundamental duties,
                not just our rights. He further stated that the real strength of
                a democracy lies not in buildings or laws, but in young citizens
                who dare to care. Citizens who question with respect, listen
                with empathy, and act with courage. He also urged the youth to
                cultivate the habit of reading, as through reading, we discover
                the true essence and deeper meaning of knowledge.
                <br />
                Pulse 5, the reflective dance performance which was a tribute to
                ‘Panch Tatva’- the elemental forces symbolising human existence
                and balance, took the audience by awe and emotion.
                <br />
                The much-awaited segment, ‘Fireside Chat’, featuring the dynamic
                RJ Ginnie from Radio City India 91.1 FM, had the audience in
                splits with her trademark humour and quick wit. Her candid yet
                introspective responses to the presenters, Anya Vohra and
                Agastya Trikha, struck a perfect balance between laughter and
                reflection, making it a truly memorable highlight of the event.
                She urged the youngsters to not limit dissent to auditoriums,
                but to question and respect other’s point of view. She further
                admonished the young adults to be themselves, minus any
                ‘filters’, and not be fixated on their looks.
                <br />
                The Director, Ms Anita Malhotra, in her message,
                affirmed that the event paved a path towards transformative
                leadership where voices were heard, hard-hitting questions were
                deliberated, and values of transparency and accountability in
                the Indian parliament were strengthened.
                <br />
                The most anticipated moment arrived with the announcement of the
                awards, filling the atmosphere with excitement. Khushi Joshi,
                Charge d’Affaires, took to the podium, heightening the eagerness
                as the names of the winners were announced. The awards were
                presented by Mr Devender Mishra, RJ Ginnie, Mr Harkaran (Member,
                Managing Committee), and the Director, Ms Anita
                Malhotra, in a moment of pride and celebration.
                <br />
                The two-day empowering and enriching celebration of Lotus Sansad
                2025- Janniti se Jankalyan, from Public Policy to Public Welfare
                culminated with a Vote of Thanks by the President of Core
                Secretariat, Vivaan Banerjee. 
              </p>
            </div>
            <div className="row flexbox-v zoompic">
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-1.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-1.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-2.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-2.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-3.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-3.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-4.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-4.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-5.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-5.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-6.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-6.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-7.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-7.jpeg"
                    />
                  </div>
                </a>
              </div>

              {/* <div class="col-lg-3">
                                <a data-magnify="gallery" data-src="" data-group="a" href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-8.jpeg">
                                    <div class="lazyload-wrapper ">
                                        <img class="img-fluid" alt="Image 0" src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-8.jpeg" />
                                    </div>
                                </a>
                            </div> */}

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-9.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-9.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-10.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-10.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-11.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-11.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-12.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-12.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-13.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-13.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-14.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-14.jpeg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-15.jpeg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUS-25-15.jpeg"
                    />
                  </div>
                </a>
              </div>
            </div>

            <div
              className="magazine"
              onClick={() =>
                handleOpenModal(
                  "LOTUS SANSAD",
                  "https://online.anyflip.com/wrkqw/jwoe/mobile/index.html",
                )
              }
            >
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/LOTUSSANSAD.JPG"
                  alt="Lotus Valley School, Gurgaon"
                  className="img-fluid"
                />
              </LazyLoad>
              <p>LOTUS SANSAD</p>
            </div>
          </div>
          <br />
          <br />

          <div className="row">
            <div className="col-md-12">
              <h4>AIKYAM MUN REPORT 2025</h4>
              <p className="text-center">
                <b>
                  AIKYAM MUN 2025:Azaadi ki Goonj: From Quit India to Global
                  Voices
                  <br />
                  GRADES – VII & VIII
                </b>
                <br />
              </p>
              <p>
                <b>
                  {" "}
                  "The preservation of freedom is not the task of soldiers
                  alone. The whole nation has to be strong. ― Lal Bahadur
                  Shastri
                </b>
              </p>

              <p>
                Under the esteemed leadership of Director Principal Anita
                Malhotra, the{" "}
                <b>
                  Social Science Department along with the Students’ Executive
                  Body,
                </b>{" "}
                successfully hosted the{" "}
                <b>
                  fourth edition of AIKYAM, a Model United Nations Intra-School
                  Conference for Grades VII and VIII.
                </b>{" "}
                The event paid a stirring tribute to India’s historic struggle
                for independence through a special segment on{" "}
                <b>Azaadi ki Goonj-From Quit India to Global Voices,</b>{" "}
                rekindling the spirit of freedom and patriotic fervour among the
                young delegates.
              </p>

              <p>
                The Conference commenced with an inspiring address by
                Principal Ms. Ruchi Joshi, who emphasized the importance of
                cultivating essential life skills, embracing leadership
                reflecting national values, and striving to be exemplary role
                models and good human beings. The inaugural dance by our fifth
                graders beautifully reflected the country's values and
                traditions and infused patriotism among the audience.
              </p>

              <p>
                Secretariat members, Shreyansh Kanotra and Ananya Lakara,
                declared the conference open, leading to constructive debates
                and diplomatic discussions across various committees, which
                explored historically rooted issues with present-day relevance.
                The conference explored global and historical themes:{" "}
                <b>UNESCO</b> focused on memory sites for peace, <b>ECOSOC</b>{" "}
                on the Great Depression recovery, <b>UNCSW</b> on women's
                suffrage, <b>WHO</b> on polio and vaccine hesitancy, and{" "}
                <b>AIPPM</b> on India's post-independence integration. The{" "}
                <b>International Press</b> documented the dynamic discussions
                throughout.
              </p>

              <p>
                The conference witnessed enthusiastic participation of{" "}
                <b>145</b> learners. The event concluded with a distinguished
                Valedictory Ceremony, graciously hosted by Arjun Awasthi and
                Laisha Jain, celebrating the achievements of delegates,
                organizers, and participants. Exceptional delegates were
                honoured with awards, creating an atmosphere brimming with
                enthusiasm and pride.{" "}
                <b>
                  AIKYAM 2025 was a resounding success, promoting peer learning
                  and instilling a profound sense of achievement among the
                  students.
                </b>
              </p>
            </div>

            <div className="row flexbox-v zoompic">
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-1.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-1.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-2.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-2.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-3.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-3.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-4.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-4.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-5.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-5.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-6.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-6.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-7.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-7.JPG"
                    />
                  </div>
                </a>
              </div>
              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-8.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-8.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-9.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-9.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-10.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-10.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-11.jpg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-11.jpg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-12.jpg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-12.jpg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-13.jpg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-13.jpg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-14.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-14.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-15.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-15.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-16.jpg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-16.jpg"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-17.JPG"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-17.JPG"
                    />
                  </div>
                </a>
              </div>

              <div class="col-lg-3">
                <a
                  data-magnify="gallery"
                  data-src=""
                  data-group="a"
                  href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-18.jpg"
                >
                  <div class="lazyload-wrapper ">
                    <img
                      class="img-fluid"
                      alt="Image 0"
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAMMUN-25-18.jpg"
                    />
                  </div>
                </a>
              </div>
            </div>
            <div
              className="magazine"
              onClick={() =>
                handleOpenModal(
                  "AIKYAM 2025",
                  "https://online.anyflip.com/wrkqw/xfvc/mobile/index.html",
                )
              }
            >
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AIKYAM.JPG"
                  alt="Lotus Valley School, Gurgaon"
                  className="img-fluid"
                />
              </LazyLoad>
              <p>AIKYAM 2025</p>
            </div>
          </div>
          <br />
          <br />
          <div class="text-box">
            <p>
              Model United Nations conferences provide students with a platform
              to unleash their diplomatic and communication skills through the
              simulation of various committees of the United Nations.
            </p>
            <div class="blog-main-box">
              <div class="blogList">
                <div class="blog-img">
                  <iframe
                    src="https://www.youtube.com/embed/4fND0B9Rm8Y"
                    title="Mun"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen=""
                  ></iframe>
                </div>
                <div class="blog-text">
                  <h4 className="color-red"> MUN</h4>
                  <p>
                    Lotus Valley International School achieved yet another
                    milestone by successfully organizing the Virtual Inter
                    School LOTUSMUN2020:Dream . Discover . Conquer (Model United
                    Nations) on 11th July 2020. The conference attracted 350
                    delegates across the globe, including countries like Russia,
                    Australia and Switzerland and 14 Indian schools. Optimism is
                    the major driving force of this LOTUSMUN2020 and we hope
                    that this next generation of diplomats and leaders will
                    remember LOTUSMUN2020 as one of the moments that sharpened
                    their view for global issues and expanded their horizon.
                    Because in the end, it is “the youth of this world, that can
                    make a difference!
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box">
              <div class="blogList">
                <div class="blog-img">
                  <iframe
                    src="https://www.youtube.com/embed/dpahHKZ4JN8"
                    title="Carpe Diem'19"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen=""
                  ></iframe>
                </div>
                <div class="blog-text">
                  <h4 className="color-red">Carpe Diem'19</h4> <br />
                  <p> When Your Voice Matters</p>
                  <p>
                    {" "}
                    Lotus Valley International School Gurugram organized the
                    Intra-School Model United Nations Conference ‘Carpe
                    Diem-Seize the day when your voice matters’ on Sunday, 18th
                    August, 2019, from grades VIII-XII.{" "}
                  </p>
                  <p>
                    ‘Carpe Diem’ aimed to be an MUN conference where learners
                    debated, contemplated and deliberated effectively on various
                    global issues throughout their committee sessions and press
                    conferences under the guidance of the experienced Executive
                    Board and Secretariat members.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box">
              <div class="blogList">
                <div class="blog-img">
                  <iframe
                    src="https://www.youtube.com/embed/SU7bzfijmfU"
                    title="Opening Ceremony"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen=""
                  ></iframe>
                </div>
                <div class="blog-text">
                  <h4 className="color-red">Opening Ceremony</h4>
                  <p>
                    LotusMUN’21-’Redefining the Norm’ began with supreme verve
                    and vigour to find feasible solutions for the problems at
                    hand. The world leaders at the United Nations General
                    Assembly wrote working papers to deeply analyse the issue of
                    intolerance and provide apt solutions for the same, while
                    delegates in the United Nations Commission for the Status of
                    Women decided to reach a joint conclusion over the agenda
                    given. The United Nations Security Council convened to find
                    ways of restoring peace in Myanmar after the coup d'état of
                    1st February, 2021. The Indian politicians in Lok Sabha
                    discussed the future of India’s economy post pandemic.
                    Meanwhile, in Indian War Cabinet, government officials took
                    diplomatic and military action against the PLA around the
                    McMahon Line. Furthermore, editors-in chief of EU countries
                    congregated in European Commission on Ethical Journalism and
                    Reporting and framed a mandate for the release of sensitive
                    information regarding governance, trade ties and military.
                    In the Union of European Football Association, football
                    clubs agreed to transfer funds from the men’s football clubs
                    to the women’s; meanwhile countries in the International
                    Organisation of Securities Council, deliberated the
                    implications of short selling and market manipulation
                    through social media.
                  </p>
                  <p>
                    LotusMUN’21 was a grand success, one that the Secretariat
                    was extremely proud of. Though exhausted, the delegates
                    still brimmed with pride and joy on putting their best foot
                    forward. The journey of LotusMUN’21-’Redefining the Norm’
                    might have ended, but the learning hasn’t.
                  </p>
                </div>
              </div>
            </div>
            <div class="blog-main-box">
              <div class="blogList">
                <div class="blog-img">
                  <iframe
                    src="https://www.youtube.com/embed/G9bpL50BHUA"
                    title="Closing Ceremony"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen=""
                  ></iframe>
                </div>
                <div class="blog-text">
                  <h4 className="color-red">Closing Ceremony</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedMagazine.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={selectedMagazine.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
            title={selectedMagazine.title}
          ></iframe>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};
export default Mun;
